var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.loadingSpinner
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.loadingSpinner
        ? _c(
            "div",
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "my-md-1",
                              attrs: { md: "6", cols: "6" },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "font-weight-bold p-1 border-bottom border-right",
                                    },
                                    [_vm._v("Vehicle")]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "p-1 border-bottom border-right",
                                    },
                                    [_vm._v(_vm._s(_vm.getVehicle))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "font-weight-bold p-1 border-bottom border-right",
                                    },
                                    [_vm._v("Driver")]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "p-1 border-bottom border-right",
                                    },
                                    [_vm._v(_vm._s(_vm.getDriver))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "font-weight-bold p-1 border-bottom border-right",
                                    },
                                    [_vm._v("Pick Up Location")]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "p-1 border-bottom border-right",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.deliveryid.pickUpLocation)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "font-weight-bold p-1 border-bottom border-right",
                                    },
                                    [_vm._v("Drop Off Location")]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "p-1 border-bottom border-right",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.deliveryid.dropOffLocation)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "font-weight-bold p-1 border-bottom border-right",
                                    },
                                    [_vm._v("Delivery Date")]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "p-1 border-bottom border-right",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.deliveryid.deliveryDate
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "font-weight-bold p-1 border-bottom border-right",
                                    },
                                    [_vm._v("Delivery Status")]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "p-1 border-bottom border-right",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.deliveryid.deliveryStatus)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "font-weight-bold p-1 border-bottom border-right",
                                    },
                                    [_vm._v("Note")]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "p-1 border-bottom border-right",
                                    },
                                    [_vm._v(_vm._s(_vm.deliveryid.note))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("CustomFieldsDetails", {
                                        attrs: {
                                          AdditionalFields:
                                            _vm.deliveryid.additionalFields,
                                          ModuleReference: "Delivery",
                                          ReadOnlyFields: true,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "my-md-1",
                              attrs: { md: "6", cols: "6" },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { align: "center" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(255, 255, 255, 0.15)",
                                          expression:
                                            "'rgba(255, 255, 255, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      attrs: {
                                        variant: "primary",
                                        target: "_blank",
                                        href:
                                          "https://www.google.com/maps/dir/?api=1&origin=" +
                                          encodeURIComponent(
                                            _vm.deliveryid.pickUpLocation
                                          ) +
                                          "&destination=" +
                                          encodeURIComponent(
                                            _vm.deliveryid.dropOffLocation
                                          ),
                                      },
                                    },
                                    [_vm._v("View Delivery Route")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: { title: "Select Delivery Items", centered: "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.saveChanges },
                    },
                    [_vm._v("Save Changes")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.modalOpen,
            callback: function ($$v) {
              _vm.modalOpen = $$v
            },
            expression: "modalOpen",
          },
        },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              items: _vm.deliveryItems,
              fields: _vm.deliveryItemFieldsModal,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(invoiceNo)",
                fn: function (data) {
                  return [
                    _vm._v(" " + _vm._s(data.item.invoice.invoiceNo) + " "),
                  ]
                },
              },
              {
                key: "cell(itemId)",
                fn: function (data) {
                  return [
                    _c("span", [
                      _vm._v(
                        " " + _vm._s(_vm.getProductName(data.item.itemId))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(check)",
                fn: function (row) {
                  return [
                    _c("b-form-checkbox", {
                      model: {
                        value: row.item.selected,
                        callback: function ($$v) {
                          _vm.$set(row.item, "selected", $$v)
                        },
                        expression: "row.item.selected",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      !_vm.loadingSpinner
        ? _c(
            "b-card",
            { staticClass: "mt-3" },
            [
              _c("b-card-header", [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center m-1",
                  },
                  [_c("div", [_vm._v("Selected Delivery Item Details")])]
                ),
              ]),
              _c(
                "b-col",
                { attrs: { cols: "12", md: "4", xl: "3" } },
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(186, 191, 199, 0.15)",
                              expression: "'rgba(186, 191, 199, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          staticClass: "mb-75",
                          attrs: { variant: "primary", block: "" },
                          on: {
                            click: function ($event) {
                              return _vm.handleDeliveryDocBtn(_vm.id)
                            },
                          },
                        },
                        [_vm._v(" Documents ")]
                      ),
                      _c(
                        "b-modal",
                        {
                          ref: "modal-view-delivery-document",
                          attrs: {
                            id: "modal-view-delivery-document",
                            "ok-only": "",
                            "ok-title": "View",
                            centered: "",
                            size: "lg",
                            title: "View Documents",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("DocumentUpload", {
                            attrs: { documentDetails: _vm.documentDetails },
                            on: {
                              deleteFile: _vm.deleteFile,
                              downloadFile: _vm.downloadFile,
                              uploadFiles: _vm.uploadFiles,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-card-body",
                [
                  !_vm.loadingSpinner2
                    ? _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          items: _vm.selectedItemsWithStatus,
                          fields: _vm.selectedItemFields,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(productID)",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getProductName(data.item.productID)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(invoiceNo)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "/invoice/view/" +
                                          data.item.deliveryNote.invoice.id,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            data.item.deliveryNote.invoice
                                              .invoiceNo
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(customer)",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        data.item.deliveryNote.invoice
                                          .leadClient &&
                                          data.item.deliveryNote.invoice
                                            .leadClient.type == 1
                                          ? data.item.deliveryNote.invoice
                                              .leadClient.companyName
                                          : (
                                              (data.item.deliveryNote.invoice
                                                .leadClient.surname || "") +
                                              " " +
                                              (data.item.deliveryNote.invoice
                                                .leadClient.otherName || "")
                                            ).trim()
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(address)",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (data.item.deliveryNote.invoice
                                          .leadClient.addressLine1 || "") +
                                          " " +
                                          (data.item.deliveryNote.invoice
                                            .leadClient.addressLine2 || "")
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(quantity)",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        data.item.deliveryNote.quantity || ""
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(status)",
                              fn: function (row) {
                                return [
                                  row.item.status !== "DELIVERED" &&
                                  row.item.editingStatus
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                          on: {
                                            click: function ($event) {
                                              return _vm.editField(
                                                row.item,
                                                "editingStatus"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "b-badge",
                                            {
                                              attrs: {
                                                variant: _vm.getStatusColor(
                                                  row.item.status
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getStatusText(
                                                    row.item.status
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("feather-icon", {
                                            staticClass: "ml-2",
                                            attrs: { icon: "EditIcon" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              options:
                                                _vm.deliveryStatusV2Options,
                                              disabled:
                                                row.item.status ===
                                                  "DELIVERED" &&
                                                row.item.hasSignature == true,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.saveField(
                                                  row.item,
                                                  "editingStatus"
                                                )
                                              },
                                            },
                                            model: {
                                              value: row.item.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "row.item.status",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(comment)",
                              fn: function (data) {
                                return [
                                  !data.item.editingComment
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                          on: {
                                            click: function ($event) {
                                              return _vm.editCommentField(
                                                data.item,
                                                "editingComment"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                data.item.deliveryNote.comment
                                              )
                                            ),
                                          ]),
                                          _c("feather-icon", {
                                            staticClass: "ml-2",
                                            attrs: { icon: "EditIcon" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c("b-form-input", {
                                            on: {
                                              change: function ($event) {
                                                return _vm.saveCommentField(
                                                  data.item,
                                                  "editingComment"
                                                )
                                              },
                                            },
                                            model: {
                                              value: data.item.comment,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  data.item,
                                                  "comment",
                                                  $$v
                                                )
                                              },
                                              expression: "data.item.comment",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(actions)",
                              fn: function (data) {
                                return [
                                  data.item.status == "DELIVERED"
                                    ? _c(
                                        "div",
                                        [
                                          data.item.hasSignature == false
                                            ? _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "ripple",
                                                      rawName: "v-ripple.400",
                                                      value:
                                                        "rgba(255, 255, 255, 0.15)",
                                                      expression:
                                                        "'rgba(255, 255, 255, 0.15)'",
                                                      modifiers: { 400: true },
                                                    },
                                                  ],
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showSignaturePad(
                                                        data.item.deliveryNoteID
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Sign ")]
                                              )
                                            : _vm._e(),
                                          data.item.hasSignature == true
                                            ? _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "ripple",
                                                      rawName: "v-ripple.400",
                                                      value:
                                                        "rgba(255, 255, 255, 0.15)",
                                                      expression:
                                                        "'rgba(255, 255, 255, 0.15)'",
                                                      modifiers: { 400: true },
                                                    },
                                                  ],
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewSignature(
                                                        data.item.deliveryNoteID
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" View Signature ")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3904115020
                        ),
                      })
                    : _vm._e(),
                  _vm.loadingSpinner2
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-content-center mb-1" },
                        [
                          _c("b-spinner", {
                            staticStyle: { width: "3rem", height: "3rem" },
                            attrs: { variant: "success", label: "Spinning" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("b-card", [
        _c(
          "div",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                  [
                    _c(
                      "b-form-group",
                      { staticClass: "mb-0" },
                      [
                        _c(
                          "label",
                          { staticClass: "d-inline-block text-sm-left mr-50" },
                          [_vm._v("Per page")]
                        ),
                        _c("b-form-select", {
                          staticClass: "w-50",
                          attrs: {
                            id: "perPageSelect",
                            size: "sm",
                            options: _vm.pageOptions,
                          },
                          model: {
                            value: _vm.perPage,
                            callback: function ($$v) {
                              _vm.perPage = $$v
                            },
                            expression: "perPage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("b-col", {
                  staticClass: "my-1",
                  attrs: { md: "2", sm: "8" },
                }),
                _c("b-table", {
                  attrs: {
                    items: _vm.userlogs,
                    fields: _vm.fields,
                    striped: "",
                    responsive: "",
                    "per-page": _vm.perPage,
                    "current-page": _vm.currentPage,
                    "sort-by": _vm.sortBy,
                    "sort-desc": _vm.sortDesc,
                    "sort-direction": _vm.sortDirection,
                    filter: _vm.filter,
                    "filter-included-fields": _vm.filterOn,
                  },
                  on: {
                    "update:sortBy": function ($event) {
                      _vm.sortBy = $event
                    },
                    "update:sort-by": function ($event) {
                      _vm.sortBy = $event
                    },
                    "update:sortDesc": function ($event) {
                      _vm.sortDesc = $event
                    },
                    "update:sort-desc": function ($event) {
                      _vm.sortDesc = $event
                    },
                    filtered: _vm.onFiltered,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "cell(dateTime)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.convertTimestampToDate(data.item.dateTime)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(show_details)",
                      fn: function (row) {
                        return [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "vs-checkbox-con",
                              attrs: { plain: "" },
                              on: { change: row.toggleDetails },
                              model: {
                                value: row.detailsShowing,
                                callback: function ($$v) {
                                  _vm.$set(row, "detailsShowing", $$v)
                                },
                                expression: "row.detailsShowing",
                              },
                            },
                            [
                              _c("span", { staticClass: "vs-checkbox" }, [
                                _c(
                                  "span",
                                  { staticClass: "vs-checkbox--check" },
                                  [
                                    _c("i", {
                                      staticClass: "vs-icon feather icon-check",
                                    }),
                                  ]
                                ),
                              ]),
                              _c("span", { staticClass: "vs-label" }, [
                                _vm._v(
                                  _vm._s(row.detailsShowing ? "Hide" : "Show")
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "row-details",
                      fn: function (row) {
                        return [
                          _c(
                            "b-card",
                            [
                              _c(
                                "b-row",
                                { staticClass: "mb-2" },
                                [
                                  row.item.oldValues == null
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "mb-1",
                                          attrs: { md: "12" },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v("Original Values: "),
                                          ]),
                                          _vm._v("Nothing found "),
                                        ]
                                      )
                                    : _vm._e(),
                                  row.item.oldValues !== null
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "mb-1",
                                          attrs: { md: "12" },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v("Original Values: "),
                                          ]),
                                          _c("b-table", {
                                            attrs: {
                                              items: _vm.beautifyJson(
                                                row.item.oldValues
                                              ),
                                              fields: ["key", "value"],
                                              bordered: "",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mb-1",
                                      attrs: { md: "12" },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v("Changed Values: "),
                                      ]),
                                      _c("b-table", {
                                        attrs: {
                                          items: _vm.beautifyJson(
                                            row.item.newValues
                                          ),
                                          fields: ["key", "value"],
                                          bordered: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("b-pagination", {
                      staticClass: "my-0",
                      attrs: {
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage,
                        align: "center",
                        size: "sm",
                      },
                      model: {
                        value: _vm.currentPage,
                        callback: function ($$v) {
                          _vm.currentPage = $$v
                        },
                        expression: "currentPage",
                      },
                    }),
                    _c("b-form-group", [
                      _vm._v(
                        " Showing " +
                          _vm._s(
                            _vm.totalRows > 0
                              ? _vm.perPage * (_vm.currentPage - 1) + 1
                              : 0
                          ) +
                          " to " +
                          _vm._s(
                            _vm.totalRows > 0
                              ? Math.min(
                                  _vm.perPage * _vm.currentPage,
                                  _vm.totalRows
                                )
                              : 0
                          ) +
                          " of " +
                          _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                          " entries "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-modal",
        {
          ref: "signatureModalOpen",
          attrs: {
            title: "Digital Signature",
            "hide-footer": "",
            centered: "",
          },
        },
        [
          _c("VueSignaturePad", {
            ref: "signaturePad",
            staticStyle: {
              border: "1px solid #ccc",
              "background-color": "#fff",
            },
            attrs: {
              id: "signature",
              width: "100%",
              height: "30vh",
              options: {
                onBegin: function () {
                  _vm.$refs.signaturePad.resizeCanvas()
                },
              },
            },
          }),
          _c(
            "div",
            { staticClass: "text-center mt-3" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-1",
                  attrs: { variant: "success" },
                  on: { click: _vm.saveSignature },
                },
                [_vm._v("Save")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "mr-1",
                  attrs: { variant: "warning" },
                  on: { click: _vm.undo },
                },
                [_vm._v("Undo")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "danger" },
                  on: { click: _vm.clearSignature },
                },
                [_vm._v("Clear")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "viewSignatureModalOpen",
          attrs: {
            title: "View Signature",
            "hide-footer": "",
            centered: "",
            size: "md",
          },
        },
        [
          _c("img", {
            staticStyle: {
              width: "100%",
              height: "30vh",
              border: "1px solid #ccc",
              "background-color": "#fff",
            },
            attrs: { src: _vm.signatureData, alt: "Digital Signature" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }